import { TnbUser } from './tnb-user';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Injectable, inject } from '@angular/core';
import { AuthenticationService } from './authentication.service';

@Injectable()
export class ProfileResolver implements Resolve<TnbUser> {
    private authenticationService = inject(AuthenticationService);

    async resolve(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Promise<TnbUser> {
        return this.authenticationService.user;
    }
}
